<template>
  <div class="page">
	<div class="sidebar">
		<sidebar></sidebar>
	</div>
  	<div class="pageContainer">
  		<div class="pageTitle">
  			<h3>国际学院版画联盟展的背景和现状</h3>
  			<!-- <small>/ 国际学院版画联盟</small> -->
  		</div>
  		<div class="pageContent">
  			<div class="pageArticle">
  				<p>金秋的北京，版画界双喜临门。在全球疫情不稳定的情况下，中国在控制疫情方面取得了傲人的成绩，国际学院版画联盟突破重重困难，通过云展览的方式，正常举办了第三届国际学院版画联盟大展；同时，中央美术学院国际版画研究院，在中央美术学院领导和国际版画界朋友们的大力支持下如期举行成立揭牌仪式，这也是全球版画人的盛事。</p>
	  			<p>2016年10月，由中央美术学院发起的“国际学院版画联盟”在北京正式成立，标志着国际版画事业已经有实体交流和发展平台，对促进不同文化语境下版画创作研究的理解与融合具有重要意义。是国际间版画事业同行进行知识共享、实践互助和学术交流的专业组织平台。联盟成员汇集世界的版画领袖和学术精英，共同实现版画这个具有国际语言的艺术的未来与发展。</p>
	  			<p>“首届国际学院版画联盟邀请展”也在北京太庙艺术馆成功举办。来自30个国家的600余件版画作品在中国皇家庙堂盛况空前的展示，彰显了中国国家实力和文化自信，在世界版画史上也是首次。</p>
	  			<p>2018年9月联盟又在中国景德镇陶溪川美术馆举办了“第二届国际学院版画联盟大展和学术研讨会，这一届展览又增加了来自4个国家的6所学院为成员。</p>
	  			<p>两次大展产生了广泛的国际影响力，尤其是第二届大展和学术研讨会上，王华祥主席提出的重新定义当代版画的倡议和大会最后的决议。为当代版画创作拓展了新通道。显现了联盟的学术影响力和意义。</p>
	  			<p>2016至2019年联盟在南京、贵州、厦门进行巡展，期间联盟在中国中央美术学院举办了“国际木口木刻版画作品及文献展”展出了九个成员国，100余位艺术家200多幅作品。之后又在中国天津美术学院、四川美术学院、湖北美术学院和江苏淮安美术馆举办了巡展，还在意大利、波兰进行了学术交流和展览。</p>
	  			<p>在举办展览和学术研讨会的同时，联盟也十分注重互联网和移动媒体平台的建设和发展，以便于和联盟成员进行密切的交流与沟通。</p>
	  			<p>今年，由于全球范围内的疫情发展，“国际学院版画联盟”和中央美术学院国际版画研究院，克服了重重困难，成功地组织了此次云展览。我们邀请了全球近30个国家40余所学院的艺术家参加了云展览，比前两届增加了10余所，有470余幅作品参展，版画装置等新形式的版画也出现在展览中，代表了国际版画发展的最新水平。同时，还举办了学术论坛，来自全球的30余位版画学者和艺术家通过云在线的方式进行学术研讨和交流。在特殊时期为中外艺术家提供的一个全新的交流与展示平台，对于繁荣版画艺术与市场、提高创作与鉴赏水平、提升版画艺术影响力具有十分重要的意义。</p>
	  			<p>中国当代版画艺术在国际版画界影响力不断增强的背景下，联盟成功地举办了两届国际学院版画联盟大展。此次展览又确定为双年展的形式，为适应国际间版画交流的迫切需要，中央美术学院成立国际版画研究院，为双年展提供支持和保障。国际版画研究院的成立将进一步促进国际版画教学、创作、研究、技术创新与市场开发，提升国际版画学术交流的深度和广度。</p>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script type="text/ecmascript-6">
	import Sidebar from 'base/sidebar/sidebar'
	export default {
	  	components: {
	  		Sidebar
	  	}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageContent {
	    padding: 54px 30px;
	}
	.pageArticle .right{
		text-align: right;
	}
	@media screen and (max-width:750px) {
		.pageContent {
		    padding: .4rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/about/about.vue